import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CheckCircle, BookOpen, Star } from 'lucide-react';
export function Hero() {
  return <section id="inicio" className="relative min-h-[90vh] flex items-center justify-center py-16 px-4 overflow-hidden bg-[#FEFBF4]" data-id="element-121">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10" data-id="element-122">
        <div className="absolute -top-[10%] -right-[10%] w-[50%] h-[50%] rounded-full bg-[#1B4332] blur-3xl" data-id="element-123" />
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-[#D97706] blur-3xl" data-id="element-124" />
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-125">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center lg:text-left" data-id="element-126">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="inline-flex items-center gap-2 bg-[#86EFAC]/20 text-[#1B4332] px-4 py-1.5 rounded-full text-sm font-medium mb-6" data-id="element-127">
            <Star className="w-4 h-4 fill-[#D97706] text-[#D97706]" data-id="element-128" />
            <span data-id="element-129">
              Más de 2,000 personas ya transformaron su relación con la comida
            </span>
          </motion.div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1B4332] leading-tight mb-6" data-id="element-130">
            Dejá de Adivinar Qué Comer y Empezá a Vivir Sin Miedo a Tu Diabetes
          </h1>

          <p className="text-lg md:text-xl text-[#1C1917]/80 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-131">
            El pack completo de guías prácticas + herramientas diarias que te
            dicen exactamente qué comer, qué comprar y cómo organizarte — sin
            dietas imposibles ni información contradictoria.
          </p>

          <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-132">
            <CTAButton text="Quiero Mi Pack Completo" size="xl" pulse={true} data-id="element-133" />

            <div className="flex flex-wrap justify-center lg:justify-start gap-x-6 gap-y-2 text-sm text-[#1C1917]/70 mt-4" data-id="element-134">
              <span className="flex items-center gap-1" data-id="element-135">
                <CheckCircle className="w-4 h-4 text-[#1B4332]" data-id="element-136" /> Acceso
                inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-137">
                <CheckCircle className="w-4 h-4 text-[#1B4332]" data-id="element-138" /> Garantía de 7
                días
              </span>
              <span className="flex items-center gap-1" data-id="element-139">
                <CheckCircle className="w-4 h-4 text-[#1B4332]" data-id="element-140" /> Formato
                digital descargable
              </span>
            </div>
          </div>
        </motion.div>

        {/* Visual Content / Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative hidden lg:block" data-id="element-141">
          <div className="relative w-full aspect-square max-w-lg mx-auto" data-id="element-142">
            <div className="absolute inset-0 bg-[#1B4332]/5 rounded-full blur-2xl transform scale-90" data-id="element-143" />

            {/* Abstract representation of the pack */}
            <div className="relative z-10 grid grid-cols-2 gap-4 p-4" data-id="element-144">
              <div className="bg-white p-6 rounded-2xl shadow-xl transform rotate-[-6deg] translate-y-8 border border-gray-100" data-id="element-145">
                <div className="h-40 bg-[#1B4332]/10 rounded-lg mb-4 flex items-center justify-center" data-id="element-146">
                  <BookOpen className="w-16 h-16 text-[#1B4332]" data-id="element-147" />
                </div>
                <div className="h-4 w-3/4 bg-gray-200 rounded mb-2" data-id="element-148" />
                <div className="h-4 w-1/2 bg-gray-200 rounded" data-id="element-149" />
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-xl transform rotate-[6deg] border border-gray-100" data-id="element-150">
                <div className="h-40 bg-[#D97706]/10 rounded-lg mb-4 flex items-center justify-center" data-id="element-151">
                  <BookOpen className="w-16 h-16 text-[#D97706]" data-id="element-152" />
                </div>
                <div className="h-4 w-3/4 bg-gray-200 rounded mb-2" data-id="element-153" />
                <div className="h-4 w-1/2 bg-gray-200 rounded" data-id="element-154" />
              </div>

              <div className="col-span-2 bg-white p-4 rounded-xl shadow-lg transform -translate-y-8 scale-95 border border-gray-100 flex items-center gap-4" data-id="element-155">
                <div className="bg-[#86EFAC]/30 p-3 rounded-full" data-id="element-156">
                  <CheckCircle className="w-6 h-6 text-[#1B4332]" data-id="element-157" />
                </div>
                <div data-id="element-158">
                  <p className="font-bold text-[#1B4332]" data-id="element-159">Pack Completo</p>
                  <p className="text-sm text-gray-500" data-id="element-160">3 Guías + 14 Bonus</p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}